import { gql } from '@apollo/client';

export const CREATE_SCHOOL_PROGRESSION_DATAS = gql`
  mutation createSchoolProgressionDatas($inputs: [CreateSchoolProgressionDataInput!]!) {
    progressions: createSchoolProgressionDatas(inputs: $inputs) {
      id
    }
  }
`;
